import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export type CardProps = HTMLAttributes<HTMLDivElement>;

const baseClasses =
  'rounded-lg border border-[var(--border-subtle)] bg-[var(--surface-raised)] ' +
  'p-6 text-[var(--text-primary)]';

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, ...rest },
  ref,
) {
  return <div ref={ref} className={cn(baseClasses, className)} {...rest} />;
});
